<template>
  <!-- V for textData, span if !highlighted, mark if highlighted -->
  <div :class="{ 'break-word': wordWrap }" v-html="renderedText"></div>
</template>
<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    text: { required: false, type: String, default: '' },
    filter: { required: false, type: String, default: '' },
    wordWrap: { required: false, type: Boolean as PropType<boolean>, default: false },
  },
  setup(props) {
    const renderedText = computed(() => {
      if (props.filter != undefined && props.filter.length > 0) {
        const re = new RegExp(props.filter, 'ig')
        if (props.text != undefined) {
          const results = props.text.replaceAll(re, '<mark>$&</mark>')
          return results
        }
      }
      return props.text
    })

    return {
      renderedText,
    }
  },
})
</script>

<style scoped>
.break-word {
  word-wrap: break-word;
}
</style>
